module.exports = __webpack_public_path__ + "assets/img/25_315.d5831cb1.jpg";